"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z
    .object({
    lngLat: zod_1.z.string(),
    maxFlowRateGpm: zod_1.z.number().positive().nullable().optional(),
    minFlowRateGpm: zod_1.z.number().positive().nullable().optional(),
    seasonStartDate: zod_1.z.string().nullable().optional(),
    propertyId: zod_1.z.number(),
    isDeleteLimits: zod_1.z.boolean().optional(),
})
    .array();
exports.responseSchema = zod_1.z
    .boolean()
    .or(zod_1.z.object({
    error: zod_1.z.string(),
}))
    .nullable();
//# sourceMappingURL=update.js.map